<template>
  <LayoutHeader main="help" ref="layout" :loadingOverlay="loadingOverlay" :me="me">
    <article>
      <iframe src="https://docs.google.com/document/d/e/2PACX-1vScV2zoCIXuf37bFgNpt6njH_mg0mFtSViiROQDXyhuLbHvKvk1i7wrUFRv8kEpa32kse1nk7wT4fkI/pub?embedded=true"></iframe>
    </article>
  </LayoutHeader>
</template>

<script>
import baseMixin from './base'

export default {
  mixins: [
    baseMixin,
  ],
}
</script>
